/** Puestos con acceso a Twilio CEAA (menú + ruta). */
export const PUESTOS_TWILIO_CEAA = [
  11, // JEFE DE TI
]

export function puedeVerTwilioCEAA(usuario) {
  if (!usuario) return false
  const puesto = usuario.idpuesto != null && usuario.idpuesto !== '' ? usuario.idpuesto : usuario.id_puesto
  return PUESTOS_TWILIO_CEAA.includes(Number(puesto))
}
